<section class="esn-hierarchy">
  <header class="esn-hierarchy__header">
    <div class="esn-hierarchy__titles">
      <h2 class="esn-hierarchy__title">{{ heading() }}</h2>
      @if (subheading(); as s) {
        <p class="esn-hierarchy__subtitle">{{ s }}</p>
      }
    </div>
    <esn-button variant="secondary" (clicked)="toggleAll()">
      {{ anyExpanded() ? collapseAllLabel() : expandAllLabel() }}
    </esn-button>
  </header>

  <ng-content select="esn-version-tabs" />

  <div
    class="esn-hierarchy__board"
    [class.esn-hierarchy__board--dragging]="dragging()"
    #board
    role="group"
    tabindex="0"
    [attr.aria-label]="boardLabel()"
    (pointerdown)="onPointerDown($event)"
    (keydown)="onBoardKeydown($event)"
  >
    <div
      class="esn-hierarchy__canvas"
      [style.width.px]="layout().width"
      [style.height.px]="layout().height"
      [style.transform]="canvasTransform()"
    >
      <svg
        class="esn-hierarchy__connectors"
        [attr.width]="layout().width"
        [attr.height]="layout().height"
        [attr.viewBox]="'0 0 ' + layout().width + ' ' + layout().height"
        fill="none"
        aria-hidden="true"
      >
        @for (d of layout().paths; track $index) {
          <path [attr.d]="d" />
        }
      </svg>

      @for (placed of layout().nodes; track placed.node.id) {
        <esn-spatial-node
          class="esn-hierarchy__node"
          [style.left.px]="placed.x"
          [style.top.px]="placed.y"
          [type]="placed.type"
          [label]="placed.node.label"
          [subtitle]="placed.node.subtitle ?? null"
          [expanded]="isOpen(placed.node.id)"
          (expandedChange)="setOpen(placed.node.id, $event)"
          (click)="activate(placed.node, $event)"
        />
      }
    </div>

    <div class="esn-hierarchy-zoom">
      <button type="button" class="esn-hierarchy-zoom__button" [attr.aria-label]="zoomOutLabel()" [attr.title]="zoomOutLabel()" [disabled]="!canZoomOut()" (click)="zoomOut()">
        <esn-icon name="zoom-out" [size]="14" />
      </button>
      <span class="esn-hierarchy-zoom__value" aria-live="polite">{{ zoomPercent() }}</span>
      <button type="button" class="esn-hierarchy-zoom__button" [attr.aria-label]="zoomInLabel()" [attr.title]="zoomInLabel()" [disabled]="!canZoomIn()" (click)="zoomIn()">
        <esn-icon name="zoom-in" [size]="14" />
      </button>
    </div>
  </div>
</section>
